<ng-container [formGroup]='targetingForm'>
  <hr class='subDivider'>
  <h3>{{ 'campaign.location.title' | translate }}</h3>
  <div formArrayName='namedLocationTargets' class='d-flex flex-column align-items-center text-center'>
    <p class='mb-2'>
      <span [innerHTML]="'campaign.location.descriptionPrefix' | translate"></span><strong
      *ngIf='selectedNamedLocationsInnerHtml() as namedLocationInnerHtmlList'><span
      *ngIf='namedLocationInnerHtmlList.length === 0'>{{ 'campaign.location.any' | translate }}</span><span
      *ngIf='namedLocationInnerHtmlList.length > 0'><ng-container
      *ngFor='let namedLocationInnerHtml of namedLocationInnerHtmlList; let isLast=last'><span
      [innerHTML]='namedLocationInnerHtml'></span><span
            *ngIf='!isLast' translate='grammar.listSeparator'></span> </ng-container></span></strong>
    </p>
    <div class="row align-items-center mb-2">
      <div class="col-auto">
        <input type="text" name="Search Locations" [formControl]="searchControl" class="form-control" [placeholder]="'campaign.targeting.search' | translate" style="width: 250px">
      </div>
      <div class="col-auto">
        <div class="form-check small">
          <input type="checkbox" [formControl]="showAllControl" class="form-check-input" [id]="'showAll' + uuid">
          <label class="form-check-label" [for]="'showAll' + uuid">{{'campaign.targeting.showAll' | translate}}</label>
        </div>
      </div>
    </div>
    <div *ngIf="!showAllControl.value && (searchControl.value || '').length < 1">
      <div>{{'campaign.location.results' | translate: {'options': unfilteredOptions.length} }}</div>
    </div>
    <div *ngIf="showAllControl.value || (searchControl.value || '').length > 0">
      <ul class="list-unstyled" style="column-count: 4">
        <li *ngFor='let option of options; let i = index' style="text-align: left">
          <span *ngIf="'namedLocationTarget_'+uuid+i as id" class='form-check form-check-inline'>
            <input
              class='form-check-input'
              type='checkbox'
              [formControlName]='option.controlIndex'
              [id]='id'
            />
            <label class='form-check-label' [for]='id' [innerHTML]='option.innerHtml'></label>
            <div class="small" style="color: #666">{{option.sub}}</div>
          </span>
        </li>
      </ul>
    </div>
    <div *ngIf='granularOptions.length'>
      <div class='small'><a class='ngClick' (click)='collapse.toggle()' [attr.aria-expanded]='!granularLinkCollapsed'>
        <i class='fas fa-chevron-right small' [ngClass]='{"fa-rotate-90": !granularLinkCollapsed}'></i>
        <span translate='campaign.location.moreGranular'></span>
      </a>
      </div>
      <div #collapse='ngbCollapse' [(ngbCollapse)]='granularLinkCollapsed'>
        <ng-container *ngFor='let option of granularOptions; let i = index'>
        <span *ngIf="'namedGranularLocationTarget_'+uuid+i as id" class='form-check form-check-inline'>
          <input
            class='form-check-input'
            type='checkbox'
            [formControlName]='option.controlIndex'
            [id]='id'
          />
          <label class='form-check-label' [for]='id' [innerHTML]='option.innerHtml'></label>
        </span>
        </ng-container>
      </div>
    </div>
    <div class='form-text mt-0'>{{ 'campaign.location.instructions' | translate }}</div>
  </div>
</ng-container>
